// Header JS Code
// Header Hover Code
document.querySelectorAll('.sub_menublock').forEach(menuBlock => {
  menuBlock.addEventListener('mouseenter', function() {
    document.querySelectorAll('.sub_menu_link').forEach(link => {
      link.style.opacity = '0.5';
      link.style.fontWeight = 'normal';
    });
    this.querySelectorAll('.sub_menu_link').forEach(link => {
      link.style.opacity = '1';
      link.style.fontWeight = '600';
    });
  });

  menuBlock.addEventListener('mouseleave', function() {
    document.querySelectorAll('.sub_menu_link').forEach(link => {
      link.style.opacity = '';
      link.style.fontWeight = '';
    });
  });
});

document.querySelectorAll('.link-faded-reverse').forEach(link => {
  link.addEventListener('mouseenter', () => {
    document.querySelectorAll('.link-faded-reverse').forEach(otherLink => {
      if (otherLink !== link) {
        otherLink.style.opacity = '0.5';
        otherLink.style.fontWeight = 'normal';
      } else {
        otherLink.style.opacity = '1';
        otherLink.style.fontWeight = '600';
      }
    });
  });

  link.addEventListener('mouseleave', () => {
    document.querySelectorAll('.link-faded-reverse').forEach(otherLink => {
      otherLink.style.opacity = '';
      otherLink.style.fontWeight = '';
    });
  });
});


// Mobile Menu navigation drawer
document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector(".openmobile_menu");
  const mobileDrawer = document.querySelector("mobile-navigation-drawer");
  const hamburgerIcon = document.querySelector(".icon-hamburger");
  const closeIcon = document.querySelector(".icon-close");

  function toggleMenu() {
    if (window.innerWidth <= 1199) {
      mobileDrawer.classList.toggle("open");
      const isOpen = mobileDrawer.classList.contains("open");
      closeIcon.classList.toggle("hidden", !isOpen);
      hamburgerIcon.classList.toggle("hidden", isOpen);
    }
  }

  if (menuButton && mobileDrawer) {
    menuButton.addEventListener("click", toggleMenu);
  }

  window.addEventListener("resize", function () {
    if (window.innerWidth > 1199) {
      mobileDrawer.classList.remove("open");
      closeIcon.classList.add("hidden");
      hamburgerIcon.classList.remove("hidden");
    }
  });
});


// mobile menu tabs
document.addEventListener("DOMContentLoaded", (event) =>  {
  var $tabs = $('#tabs-nav li');
  var totalTabs = $tabs.length;
  var currentTab = 0;
  function showTab(index) { 
    $tabs.removeClass('active');
    $tabs.eq(index).addClass('active');
    $('.tab_content').hide();
    $('.tab_content').eq(index).fadeIn();
  } 
  showTab(currentTab);
  $tabs.click(function () {
    currentTab = $(this).index();
    showTab(currentTab);
  });
});

// mobile menu products slider
document.addEventListener("DOMContentLoaded", () => {
  const swiperContainer = document.querySelector(".mobile_menu .block_inner");
  const slides = swiperContainer.querySelectorAll(".mobile_menu .swiper-slide");

  if (slides.length === 1) {
    slides[0].style.width = "100%";
    swiperContainer.classList.add("single-slide");
  } else {
    const swiper = new Swiper(".mobile_menu .block_inner", {
      loop: false,
      navigation: {
        nextEl: ".mobile_menu .swiper-button-next",
        prevEl: ".mobile_menu .swiper-button-prev",
      },
      slidesPerView: 1.4,
      spaceBetween: 10,
      on: {
        init: function () {
          checkButtons(this);
        },
        slideChange: function () {
          checkButtons(this);
        },
      },
    });

    function checkButtons(swiper) {
      const prevBtn = document.querySelector(".swiper-button-prev");
      const nextBtn = document.querySelector(".swiper-button-next");

      prevBtn.disabled = swiper.isBeginning;
      nextBtn.disabled = swiper.isEnd;

      prevBtn.classList.toggle("disabled", swiper.isBeginning);
      nextBtn.classList.toggle("disabled", swiper.isEnd);
    }
  }
});
// Header JS Code End


// product card variant and subscription plan code 
document.addEventListener("DOMContentLoaded", function() {
  const radios = document.querySelectorAll(".cus_variant_radio");

  if (radios.length > 0) {
    radios[0].checked = true;

    let firstProductId = radios[0].dataset.productId;
    let hiddenInput = document.querySelector(`#variant-input-${firstProductId}`);
    if (hiddenInput) {
      hiddenInput.value = radios[0].value;
    }
  }

  radios.forEach(function(radio) {
    radio.addEventListener("change", function() {
      let productId = this.dataset.productId;
      let hiddenInput = document.querySelector(`#variant-input-${productId}`);
      if (hiddenInput) {
        hiddenInput.value = this.value;
      }
    });
  });
});

// subscription plan code 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom_subcription').forEach(function (widget) {
    const productId = widget.getAttribute('data-product-id');
    const radios = widget.querySelectorAll('input[type="radio"][name^="purchase_type_"]');
    const frequency = widget.querySelector('.subscription-frequency');
    const planSelect = widget.querySelector('select[name="selling_plan_select"]');
    const hiddenPlanInput = document.getElementById(`selling-plan-input-${productId}`);
    function updateSellingPlan() {
      const selectedRadio = widget.querySelector('input[type="radio"]:checked');
      if (!selectedRadio) return;

      if (selectedRadio.value === 'subscription') {
        frequency.style.display = 'block';
        hiddenPlanInput.value = planSelect.value; 
      } else {
        frequency.style.display = 'none';
        hiddenPlanInput.value = '';
      }
    }
    radios.forEach(radio => {
      radio.addEventListener('change', updateSellingPlan);
    });
    planSelect.addEventListener('change', function() {
      const selectedRadio = widget.querySelector('input[type="radio"]:checked');
      if (selectedRadio && selectedRadio.value === 'subscription') {
        hiddenPlanInput.value = planSelect.value;
      }
    });

    updateSellingPlan();
  });
  
   // subscription plan price code ZF
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.custom_subcription').forEach(function (widget) {
        const dropdown = widget.querySelector('.selling-plan-dropdown');
        const priceSpan = widget.querySelector('.discounted-price');
        if (!dropdown || !priceSpan) return;
        const selectedInitialOption = dropdown.options[dropdown.selectedIndex];
        const initialPrice = selectedInitialOption.getAttribute('data-price');
        priceSpan.innerHTML = initialPrice;
        dropdown.addEventListener('change', function () {
          const selectedOption = dropdown.options[dropdown.selectedIndex];
          const price = selectedOption.getAttribute('data-price');
          if (price) {
            priceSpan.innerHTML = price;
          }
        });
      });
    });                    
    function isMobile() {
      return window.innerWidth <= 991;
    }
    document.querySelectorAll('.button_variants_wrapper').forEach(function(card) {
      const form = card.querySelector('form');
      const hasCustomVariant = card.querySelector('.custom_variant') !== null;
      const hasCustomSubscription = card.querySelector('.custom_subcription') !== null;
    
      card.addEventListener('click', function(e) {
        if (!isMobile()) {
          return;
        }
        if (e.target.closest('.custom_variant') || e.target.closest('.custom_subcription')) {
          return;
        }
        if ((hasCustomVariant || hasCustomSubscription) && !card.classList.contains('active')) {
          e.preventDefault();
          card.classList.add('active');
        }
      });
      form.addEventListener('submit', function(e) {
        if (!isMobile()) {
          return;
        }
        if ((hasCustomVariant || hasCustomSubscription) && !card.classList.contains('active')) {
          e.preventDefault();
        }
      });
    });
});

// Footer Image Height 
document.addEventListener("DOMContentLoaded", function () {
  matchFooterImageHeight();
});
window.addEventListener("resize", matchFooterImageHeight);
  function matchFooterImageHeight() {
    const footerWrapper = document.querySelector(".footer__wrapper");
    const footerImage = document.querySelector(".footer_image");
  
    if (footerWrapper && footerImage) {
        const wrapperHeight = footerWrapper.offsetHeight;
        footerImage.style.height = wrapperHeight + "px";
    }
}

// Blog Prose Extra Content 
setTimeout(() => {
  const contentEl = document.getElementById('article-content1');
  if (contentEl) {
    contentEl.innerHTML = contentEl.innerHTML.replace(/\[[^\]]+\]/g, '');
  }
}, 1000);

setTimeout(() => {
  document.querySelectorAll('.blog_card_content').forEach(el => {
    el.innerHTML = el.innerHTML.replace(/\[.*?\]/g, '');
  });
}, 50);

// PDP Js Code Start
document.addEventListener('DOMContentLoaded', function() {
  $('.main__product .gallery_inner_main').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    variableWidth: false,
    fade: true,
    cssEase: 'linear',
    arrow: true,
    focusOnSelect: true,
    asNavFor: '.main__product .gallery_inner_thumbnail',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          fade: false,
          centerMode: false,
          draggable: true,
          infinite: false,
          variableWidth: true,
          swipe: true
        }
      }
    ]
  });
  
  $('.main__product .gallery_inner_thumbnail').slick({
    slidesToShow: 10,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      variableWidth: true,
      asNavFor: ".main__product .gallery_inner_main",
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 8,
            variableWidth: true,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        }
      ]
  });

  $('.main__product .gallery_inner_main').on('afterChange', function(event, slick, currentSlide){
  var $thumbs = $('.main__product .gallery_inner_thumbnail');

  $thumbs.find('.slick-slide').removeClass('slick-current');
  $thumbs.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('slick-current');

  $thumbs.slick('slickGoTo', currentSlide);
});


  
  function updateGalleryImageWidth() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 991) {
      const newWidth = windowWidth - 70;
      document.querySelectorAll('.main__product .gallery_inner_main .gallery_image').forEach(el => {
        el.style.width = `${newWidth}px`;
        el.style.height = `${newWidth}px`;
      });
    } 
  }
  updateGalleryImageWidth();
  window.addEventListener('resize', updateGalleryImageWidth);

  const galleries = document.querySelectorAll('.main__product .gallery_video');
  galleries.forEach(gallery => {
    const video = gallery.querySelector('video');
    const icon = gallery.querySelector('.play-icon');
    video.pause();
    gallery.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        icon.style.display = 'none';
      } else {
        video.pause();
        icon.style.display = 'block';
      }
    });
    video.addEventListener('ended', function () {
      icon.style.display = 'block';
    });
  });

  // free gift faq code
  // $(".main__product .gift_accordion").click(function () {
  //   if($(this).hasClass('active')){
  //     $(this).removeClass('active');
  //   }else{
  //     $(".main__product .gift_accordion").removeClass('active');
  //     $(this).next('.main__product .gift_panel').slideToggle('300');
  //     $(this).addClass('active');
  //   }
  // });
  // $(".main__product .gift_accordion.active").next('.main__product .gift_panel').slideDown('300');

  // $(".cart_main .gift_accordion").click(function () {
  //   if($(this).hasClass('active')){
  //     $(this).removeClass('active');
  //   }else{
  //     $(".cart_main .gift_accordion").removeClass('active');
  //     $(this).next('.cart_main .gift_panel').slideToggle('300');
  //     $(this).addClass('active');
  //   }
  // });
  // $(".cart_main .gift_accordion.active").next('.cart_main .gift_panel').slideDown('300');

  $(document).ready(function () {
    // On page load: show panel if accordion is already active
    $(".cart-drawer .discount_box_accordion.active").next('.discount_box_panel').slideDown(300);
  });

  // function initializeGiftAccordion() {
  //   $(".cart-drawer .gift_accordion").off('click').on('click', function () {
  //     if ($(this).hasClass('active')) {
  //       $(this).removeClass('active');
  //     } else {
  //       $(".cart-drawer .gift_accordion").removeClass('active');
  //       $(this).addClass('active');
  //       $(this).next('.cart-drawer .gift_panel').slideToggle(300);
  //     }
  //   });
  //   $(".cart-drawer .gift_accordion.active").next('.cart-drawer .gift_panel').slideDown(300);
  // }
  // function observeCartDrawer() {
  //   const cartDrawer = document.querySelector('cart-drawer');
  //   if (!cartDrawer) return;
  //   const observer = new MutationObserver(function(mutationsList) {
  //     for (const mutation of mutationsList) {
  //       if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
  //         if (cartDrawer.hasAttribute('open')) {
  //           initializeGiftAccordion();
  //         }
  //       }
  //       if (mutation.type === 'childList') {
  //         initializeGiftAccordion();
  //       }
  //     }
  //   });
  //   observer.observe(cartDrawer, { attributes: true, childList: true, subtree: true });
  // }
  // observeCartDrawer();



  // custom subscription JS code
  $(".main__product .smartrr_accordion").click(function() {
    const radioBtn = $(this).find('input[type="radio"]');
    if (!$(event.target).is('input[type="radio"]') && !$(this).hasClass('active')) {
      radioBtn.prop('checked', true).trigger('change');
    }
  });
  $('input[name="smartrr_purchase_option"]').change(function() {
    const panel = $(this).closest('.smartrr_accordion').next('.smartrr_panel');
    $('.main__product .smartrr_panel').slideUp(300);
    $('.main__product .smartrr_accordion').removeClass('active');
    if ($(this).is(':checked')) {
      panel.slideDown(300);
      $(this).closest('.smartrr_accordion').addClass('active');
    }
  });
  $('input[name="smartrr_purchase_option"]:checked').trigger('change');
  
  const subscriptionAccordion = document.querySelector('.smartrr_accordion');
  const sellingPlanSelect = document.querySelector('.selling-plan-select');
  const hiddenInput = document.querySelector('.custom_subscription_input');
  const form = document.querySelector('form[action="/cart/add"]'); 
  const updateSubscription = () => {
    const isActive = subscriptionAccordion?.classList.contains('active');
    if (isActive) {
      console.log('hi', sellingPlanSelect.value);
      hiddenInput.value = sellingPlanSelect.value;
      const sellingPlanInput = form.querySelector('input[name="selling_plan"]') || document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      sellingPlanInput.value = sellingPlanSelect.value;
      form.appendChild(sellingPlanInput);
    } else {
      hiddenInput.value = '';
      const existingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (existingPlanInput) {
        form.removeChild(existingPlanInput);
      }
    }
    setTimeout(() => {
      const changeEvent = new Event('change', { bubbles: true });
      hiddenInput.dispatchEvent(changeEvent);
      
      if (window.Shopify && Shopify.onItemAdded) {
        Shopify.onItemAdded();
      }
    }, 50);
  };
  function initialize() {
        if (!subscriptionAccordion || !sellingPlanSelect || !hiddenInput || !form) return;
    new MutationObserver(updateSubscription).observe(subscriptionAccordion, {
      attributes: true,
      attributeFilter: ['class']
    });
    sellingPlanSelect.addEventListener('change', function() {
      if (subscriptionAccordion.classList.contains('active')) {
        updateSubscription();
      }
    });
    updateSubscription();
    document.addEventListener('change', function(e) {
      if (e.target.name === 'selling_plan') {
        hiddenInput.value = e.target.value;
      }
    });
  }
  initialize();
}); 


// Complementry Products & Price changing
let originalPrice = null;
function calculateGrandTotal() {
  const radioBtn = document.querySelector('#sub_value');
  const discountPriceElement = document.querySelector('#custom_discount_price');
  const mainProductPriceElements = document.querySelectorAll('.main__product .product_tile_price sale-price');
  let mainProductBasePrice = 0;
  if (radioBtn && discountPriceElement && radioBtn.checked) {
    mainProductBasePrice = parseFloat(discountPriceElement.textContent.replace(/[^\d.]/g, '')) || 0;
  } else if (originalPrice) {
    mainProductBasePrice = parseFloat(originalPrice) || 0;
  }
  let separateProductsTotal = Array.from(document.querySelectorAll('.horizontal_product_col.active sale-price'))
    .map(priceEl => parseFloat(priceEl.getAttribute('data-base-price')) || 0)
    .reduce((acc, price) => acc + price, 0);
  let grandTotal = mainProductBasePrice + separateProductsTotal;
  let formattedPrice = grandTotal % 1 === 0 ? `$${grandTotal}` : `$${grandTotal.toFixed(2)}`;
  mainProductPriceElements.forEach(priceElement => {
    priceElement.textContent = formattedPrice;
  });
  console.log('Grand Total Updated:', formattedPrice);
}
function updatePrices() {
  const subscriptionRadio = document.querySelector('#sub_value');
  const onetimeRadio = document.querySelector('#onetime_value');
  const discountPriceElement = document.querySelector('#custom_discount_price');
  const salePriceElements = document.querySelectorAll(
    '.product_title_col sale-price, .product-info__buy-buttons sale-price'
  );
  if (!subscriptionRadio || !onetimeRadio || !discountPriceElement || salePriceElements.length === 0) {
    console.warn('Elements missing during update.');
    return;
  }
  if (!originalPrice) {
    const text = salePriceElements[0].textContent.trim().replace(/[^\d.]/g, '');
    if (text) {
      originalPrice = text;
    }
  }
  if (subscriptionRadio.checked) {
    const newPrice = discountPriceElement.textContent.trim().replace(/[^\d.]/g, '');
    if (!newPrice) return;
    salePriceElements.forEach((el) => {
      el.textContent = `$${newPrice}`;
    });
    discountPriceElement.style.display = 'inline';
    console.log(`Discounted price applied: $${newPrice}`);
  }
  if (onetimeRadio.checked) {
    if (originalPrice) {
      salePriceElements.forEach((el) => {
        el.textContent = `$${originalPrice}`;
      });
      console.log(`Original price restored: $${originalPrice}`);
    }
    discountPriceElement.style.display = 'none';
  }
  calculateGrandTotal();
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[name="smartrr_purchase_option"]').forEach((radio) => {
    radio.addEventListener('click', updatePrices);
  });
  updatePrices();
  setTimeout(() => {
    document.querySelectorAll('.horizontal_product_col sale-price').forEach(el => {
      if (!el.getAttribute('data-base-price')) {
        el.setAttribute('data-base-price', el.textContent.replace(/[^\d.]/g, ''));
      }
    });
    let complementryProducts = document.querySelectorAll('.main__product .horizontal_product_col');
    complementryProducts.forEach(function (singleProduct) {
      let upcellButton = singleProduct.querySelector('.upcell_button');
      if (!upcellButton) return;
      upcellButton.addEventListener('click', function () {
        this.classList.toggle('active');
        this.closest('.horizontal_product_col').classList.toggle('active');
        calculateGrandTotal();
      });
    });
  }, 2000);
});


// variant and subcription price changing on mobile
document.addEventListener("DOMContentLoaded", function () {
  function updateCardPrice(card) {
    let selectedPriceText = '';

    const selectedVariant = card.querySelector(".cus_variant_radio:checked");
    if (selectedVariant) {
      const label = selectedVariant.closest("label");
      if (label) {
        const price = label.querySelector(".cus_variant_price");
        if (price) {
          selectedPriceText = price.textContent.trim();
        }
      }
    }

    const selectedPurchaseType = card.querySelector(`input[name^="purchase_type_"]:checked`);
    if (selectedPurchaseType) {
      const label = selectedPurchaseType.closest(".option_radio_wrapper");
      if (label) {
        let price = label.querySelector(".option-price .discounted-price") ||
                    label.querySelector(".option-price") ||
                    label.querySelector(".onetime_price_wrap sale-price") ||
                    label.querySelector("sale-price");
        if (price) {
          selectedPriceText = price.textContent.trim();
        }
      }
    }

    const priceDisplay = card.querySelector(".selected_price");
    if (priceDisplay) {
      priceDisplay.textContent = selectedPriceText;
    }
  }

  function bindListenersToCard(card) {
    const radios = card.querySelectorAll("input[type='radio']");
    const variantRadios = card.querySelectorAll(".cus_variant_radio");

    if (variantRadios.length > 0 && !card.querySelector(".cus_variant_radio:checked")) {
      variantRadios[0].checked = true;
    }

    radios.forEach(function (input) {
      input.addEventListener("change", function () {
        updateCardPrice(card);
      });
    });

    const dropdowns = card.querySelectorAll(".selling-plan-dropdown");
    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener("change", function () {
        updateCardPrice(card);
      });
    });

    updateCardPrice(card);
  }

  const productCards = document.querySelectorAll(".product-card");
  productCards.forEach(function (card) {
    bindListenersToCard(card);
  });
});



// product card price change 
  document.addEventListener("DOMContentLoaded", function () {
    const wrappers = document.querySelectorAll('.product-card__info');
  
    wrappers.forEach(wrapper => {
      const radios = wrapper.querySelectorAll('.purchase_type_radio');
      const subPrice = wrapper.querySelector('.sub_prices_wrapper');
  
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked && radio.value === 'subscription') {
            subPrice.classList.add('active');
          } else if (radio.checked && radio.value === 'onetime') {
            subPrice.classList.remove('active');
          }
        });
  
        // Trigger change event on page load for pre-selected options
        if (radio.checked) {
          radio.dispatchEvent(new Event('change'));
        }
      });
    });
  });